import { VariableType } from 'json-to-graphql-query';

import { DocumentValue } from '@/interfaces/documentValue';
import { EntityResource } from './entity.resource';

/**
 * Resource wartości dokumentu
 *
 * @export
 * @class DocumentValueResource
 * @extends {EntityResource<DocumentValue>}
 */
export class DocumentValueResource extends EntityResource<DocumentValue> {
  public getFields = {
    id: true,
    documentId: true,
    code: true,
    value: true
  };

  public listFields = {
    id: true,
    name: true
  };

  constructor() {
    super({
      entityName: 'documentValue'
    });
  }

  /**
   * Znajduje wartość dokumentu po id dokumentu i kodzie
   *
   * @param {number} documentId
   * @param {string} code
   * @returns {Promise<DocumentValue>}
   * @memberof DocumentValueResource
   */
  public find(documentId: number, code: string): Promise<DocumentValue> {
    const query = this.prepareOptions({
      query: {
        __variables: { documentId: 'Int!', code: 'String!' },
        documentValueFind: {
          __args: { documentId: new VariableType('documentId'), code: new VariableType('code') },
          id: true,
          code: true,
          value: true,
          documentId: true
        }
      }
    });
    return this.query({ query, variables: { documentId, code } }, 'documentValueFind');
  }
}

export const documentValueResource = new DocumentValueResource();
